// cache-buster-url-serializer.ts
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class CacheBusterUrlSerializer implements UrlSerializer {
    private defaultSerializer = new DefaultUrlSerializer();
    private readonly CACHE_PARAM = '_v';
    private readonly APP_VERSION = Date.now().toString(); // or use environment.version
    //    private readonly APP_VERSION = '101'; // or use environment.version
    parse(url: string): UrlTree {
        // Remove cache-busting parameter before parsing for route matching
        const urlWithoutCache = url.replace(new RegExp(`[?&]${this.CACHE_PARAM}=[^&]*`), '');
        return this.defaultSerializer.parse(urlWithoutCache);
    }

    serialize(tree: UrlTree): string {
        const baseUrl = this.defaultSerializer.serialize(tree);
        // Add cache-busting parameter to serialized URL
        const separator = baseUrl.includes('?') ? '&' : '?';
        return `${baseUrl}${separator}${this.CACHE_PARAM}=${this.APP_VERSION}`;
    }
}